import { mergeDeepRight } from 'ramda'
import React from 'react'

import { Gauge } from '@ant-design/plots'

import { useColors } from '../../../kiti/components/theme/_hooks/colors'
import Center from '../../../kiti/components/helpers/Center'

const _Gauge = ({ percent, invertColors, ...props }) => {
  const colors = useColors()
  const colorPalette = invertColors
    ? [colors.red, colors.yellow, colors.green]
    : [colors.green, colors.yellow, colors.red]
  const color = percent <= 0.33 ? colorPalette[0] : percent >= 0.66 ? colorPalette[2] : colorPalette[1]

  const config = mergeDeepRight(
    {
      autoFit: false,
      percent,
      axis: {
        label: {
          formatter(v) {
            return Number(v) * 100
          }
        },
        subTickLine: {
          count: 3
        }
      },
      range: {
        ticks: [0, 1 / 3, 2 / 3, 1],
        color: colorPalette
      },
      indicator: {
        pointer: {
          style: {
            stroke: colors.light2
          }
        },
        pin: {
          style: {
            stroke: colors.light2
          }
        }
      },

      statistic: {
        content: {
          formatter: ({ percent }) => `${(percent * 100).toFixed(0)}%`,
          style: {
            color,
            fontSize: 20
          }
        }
      }
    },
    props
  )

  return (
    <Center>
      <Gauge {...config} />
    </Center>
  )
}

export default _Gauge
